import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  public constructor(private dialog: MatDialog) {}

  public confirm(message?: string, title?: string, confirmButton?: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { message, title, confirmButton },
    });

    return dialogRef.afterClosed();
  }
}
